import React from "react";
import { TextField } from "@mui/material";

const CustomInputField = ({
  label,
  placeholder,
  value,
  onChange,
  multiline = false,
  rows = 1,
  fullWidth = true,
  width = "100%",
  maxWords = null,
  onLimitExceeded = null,
  ...props
}) => {
  const handleChange = (e) => {
    if (!maxWords) {
      onChange(e);
      return;
    }

    const newValue = e.target.value;
    const words = newValue.trim() === "" ? [] : newValue.trim().split(/\s+/);
    const wordCount = words.length;

    // If pasting or typing exceeds limit, trim to max words
    if (wordCount > maxWords) {
      const trimmedWords = words.slice(0, maxWords);
      const trimmedValue = trimmedWords.join(" ");
      
      // Notify parent that limit was exceeded
      if (onLimitExceeded) {
        onLimitExceeded(true);
      }
      
      // Create a new event object with the trimmed value
      const syntheticEvent = {
        ...e,
        target: {
          ...e.target,
          value: trimmedValue
        }
      };
      onChange(syntheticEvent);
      return;
    }

    // Clear the limit exceeded flag if under limit
    if (onLimitExceeded) {
      onLimitExceeded(false);
    }

    onChange(e);
  };

  return (
    <TextField
      label={label}
      placeholder={placeholder}
      value={value}
      onChange={handleChange}
      multiline={multiline}
      rows={multiline ? rows : undefined}
      fullWidth={fullWidth}
      InputLabelProps={{
        shrink: true,
      }}
      sx={{
        width: fullWidth ? "100%" : width,
        "& .MuiOutlinedInput-root": {
          backgroundColor: "#F5F5F5",
          borderRadius: "12px",
          "& fieldset": {
            borderColor: "#E1AD01",
          },
          "&:hover fieldset": {
            borderColor: "#B8941F",
          },
          "&.Mui-focused fieldset": {
            borderColor: "#E1AD01",
          },
          "&.Mui-disabled": {
            backgroundColor: "#F5F5F5",
            "& fieldset": {
              borderColor: "#E1AD01",
            },
          },
        },
        "& .MuiInputLabel-root": {
          color: "black",
          fontWeight: 600,
          padding: "4px 12px",
          borderRadius: "12px",
          backgroundColor: "rgba(204, 158, 73, 1)",
          transform: "translate(14px, -9px) scale(0.75)",
          "&.Mui-focused": {
            padding: "4px 12px",
            borderRadius: "12px",
            color: "black",
            backgroundColor: "rgba(204, 158, 73, 1)",
            transform: "translate(14px, -9px) scale(0.75)",
          },
          "&.MuiInputLabel-shrink": {
            padding: "4px 12px",
            borderRadius: "12px",
            backgroundColor: "rgba(204, 158, 73, 1)",
            transform: "translate(14px, -9px) scale(0.75)",
          },
        },
        "& .MuiInputBase-input": {
          padding: "14px 16px",
          color: "#333333",
          "&.Mui-disabled": {
            color: "#333333",
            WebkitTextFillColor: "#333333",
          }
        }
      }}
      {...props}
    />
  );
};

export default CustomInputField;